import React from "react";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "../../components/Layout/Breadcrumb";
import CPOForm from "./CPOForm";

import ScrollUp from "../../components/ScrollUpDown/ScrollUp";
import ScrollDown from "../../components/ScrollUpDown/ScrollDown";
import { getUserProfile } from "../../helpers/functions_helper";

const UpdateCPO = (props: any) => {
  const { t } = useTranslation();
  document.title = `${t("Update")} CPO | ` + process.env.REACT_APP_NAME;
  const userProfile = getUserProfile("all-cpo");

  const breadcrumbItems = [
    {
      url: "/dashboard",
      label: t("Dashboard"),
      active: false,
      hidden: userProfile.USER_TYPE === 3 ? true : false,
    },
    {
      url: "/cpo/list/all",
      label: t("CPO"),
      active: false,
    },
    {
      url: "#",
      label: `${t("Update")} CPO`,
      active: true,
    },
  ];

  return (
    <React.Fragment>
      <ScrollUp />
      <ScrollDown top={"100px"} />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbTitle={`${t("Update")} CPO`} breadcrumbItems={breadcrumbItems} />

          <CPOForm />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UpdateCPO;
